<script>
  import Alert from '../components/Alert.svelte'
  import { validateOrder } from '../models/orders.js'
  import { formatPrice } from '../services/utilities.js'

  export let products = []
  export let details = []

  let error = ''
  let discountCode = ''

  $: discountApplied =
    details.discounts.total !== 0.0 && details.discounts.coupon_code != ''

  async function applyDiscount() {
    // reset discount total
    details.discounts.total = 0.0
    details.discounts.coupon_code = discountCode

    let order = await validateOrder(products, details)

    // Regular discount code
    if (
      order.discounts &&
      order.discounts.total &&
      order.discounts.coupon_code.toLowerCase() == discountCode.toLowerCase()
    ) {
      details.discounts.terms = order.discounts.terms
      details.discounts.total = order.discounts.total
      details.discounts.free_shipping = order.discounts.free_shipping
      error = ''

      // Free shipping discount code
    } else if (order.discounts && order.discounts.free_shipping === true) {
      if (details.selected_ship_rate.shipment_charge_total_int > 0) {
        details.discounts.total =
          details.selected_ship_rate.shipment_charge_total_int
        details.discounts.free_shipping = order.discounts.free_shipping
        details.discounts.terms = order.discounts.terms
        error = ''
      } else {
        error = 'Please select your shipping rate before applying coupon'
      }

      // Not a real discount code
    } else {
      if (order.discounts && order.discounts.error) {
        error = `Failed to apply ${discountCode}. ${order.discounts.error}`
      } else {
        error = `"${discountCode}" is not a valid coupon`
      }

      discountCode = ''
      details.discounts.coupon_code = ''
      details.discounts.total = 0.0
    }
  }

  function removeDiscount(code) {
    discountCode = ''
    details.discounts.coupon_code = ''
    details.discounts.total = 0.0
  }
</script>

<style type="text/less">
  .discount {
    position: relative;
    background: var(--col-gray-100);
    border-color: var(--col-success);
    margin: var(--spacing-sm) 0 0;
    border-radius: var(--border-radius);

    .amount {
      font-size: 2rem;
      font-weight: bold;
    }

    .terms {
      color: var(--col-gray-50);
    }

    .btn {
      position: absolute;
      top: var(--spacing-xs);
      right: var(--spacing-xs);
    }
  }
</style>

{#if error != ''}
  <Alert type="danger" icon="warning">{error}</Alert>
{/if}

{#if !discountApplied}
  <div class="form-field">
    <label for="discount-code" class="form-field-label">Discount Code</label>
    <div class="form-input-group">
      <input id="discount-code" class="form-input" bind:value={discountCode} />
      <button class="btn" on:click={applyDiscount}>Apply</button>
    </div>
  </div>

{:else}
  <div class="discount card">
    <h3 class="text-success">
      <svg class="icon">
        <use href="/icons.svg#check" />
      </svg>
      Discount Added!
    </h3>

    <p class="amount">
      {#if details.discounts.free_shipping}
        Free Shipping
      {:else}{formatPrice(details.discounts.total)}{/if}
    </p>

    <p class="terms">CODE: {details.discounts.coupon_code}</p>
    <p class="terms">{details.discounts.terms}</p>

    <button
      class="btn btn-danger"
      title="Remove Discount"
      on:click={removeDiscount}>
      <svg class="icon">
        <use href="/icons.svg#clear" />
      </svg>
      Remove
    </button>
  </div>
{/if}
